import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, DestroyRef, inject , signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Lane } from 'src/app/models/route';
import { NavigationService } from 'src/app/services/core/navigation.service';
import { SettingsService } from 'src/app/services/account/settings.service';

@Component({
  standalone: true,
  selector: 'app-navigation-roadlanes',
  templateUrl: './navigation-roadlanes.component.html',
  imports: [CommonModule],
  styleUrls: ['./navigation-roadlanes.component.scss']
})
export class NavigationRoadlanesComponent implements OnInit {
  public readonly roadLanes = signal<Lane[]>([]);
  public readonly roadLanesVisible = signal<boolean>(false);

  private readonly destroyRef = inject(DestroyRef);

  constructor(private navigationService: NavigationService,
    public settingsService: SettingsService) { }

  ngOnInit(): void {
    this.navigationService.ObservableShowRoadLane.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((resp) => {
      if (resp != null) {
        this.roadLanesVisible.set(resp);
      }
    });
    this.navigationService.ObservableNextTurn.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((resp) => {
      if (resp && resp.NextTurnInstruction && resp.NextTurnInstruction.LaneInfo.length > 0) {
        this.roadLanes.set(resp.NextTurnInstruction.LaneInfo);
      }
      else {
        this.roadLanes.set([]);
      }
    });
  }
}
